import * as React from 'react'

type DialogRefType = { openDialog: () => void } | null

export const KnowledgeBaseContext = React.createContext<{
  initialRouteRef: React.RefObject<string | undefined | null>
  dialogRef: DialogRefType
  setDialogRef: React.Dispatch<React.SetStateAction<DialogRefType>>
  openDialog: (route?: string) => void
}>({ initialRouteRef: { current: null }, dialogRef: null, setDialogRef: () => {}, openDialog: () => {} })

/**
 * Use this hook to trigger the dialog. Returns a function with `initialPath` as parameter
 */
export function useKnowledgeBase() {
  const context = React.useContext(KnowledgeBaseContext)
  return context.openDialog
}

/**
 * Wraps entire app so that we can open the knowledge dialog from anywhere in the app
 */
export function KnowledgeBaseWrapper({ children }: React.PropsWithChildren) {
  const initialRouteRef = React.useRef<string | undefined>('/')
  const [dialogRef, setDialogRef] = React.useState<DialogRefType>(null)
  const providerValue = React.useMemo(
    () => ({
      initialRouteRef,
      dialogRef,
      setDialogRef,
      openDialog: (initialRoute?: string) => {
        initialRouteRef.current = initialRoute
        dialogRef?.openDialog?.()
      },
    }),
    [dialogRef]
  )

  return <KnowledgeBaseContext.Provider value={providerValue}>{children}</KnowledgeBaseContext.Provider>
}
